/**
 * @generated SignedSource<<520851050c786a2052035e09e8bb9603>>
 * @relayHash a7a4499a7812e744b26d0c89d9b60d67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6b94db4b79ecb7fdfcfd7e2473a7be695be478b9e25d205dd9a60c2ae9c6b053

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { Nav4ProjectsContentViewQuery } from './Nav4ProjectsContentViewQuery.graphql';

const node: PreloadableConcreteRequest<Nav4ProjectsContentViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6b94db4b79ecb7fdfcfd7e2473a7be695be478b9e25d205dd9a60c2ae9c6b053",
    "metadata": {},
    "name": "Nav4ProjectsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
